export const MODES = {
    light: 'light',
    system: 'system',
    dark: 'dark'
}